'use client';

import { TrackJSAgent } from 'trackjs-nextjs';

interface TrackJSClientProps {
  token?: string;
  application?: string;
}

export default function TrackJSClient({ token, application }: TrackJSClientProps) {
  if (!token || !application) return null;

  const config = {
    token,
    application,
    onError: () => Math.random() < 0.1, // Coleta apenas 10% dos erros
  };

  return <TrackJSAgent config={config} />;
}
